import React from "react";
import {Hamburger, HamburgerPart} from "./HamburgerMenu.styles";

const HamburgerMenu = () => {

    const toggleMobileMenu = () => {
        const navMenu = document.getElementById('nav-menu');
        const hamburgerMenu = document.getElementById('hamburger');
        navMenu.classList.toggle('active');
        hamburgerMenu.classList.toggle('active');
    }

    return (
        <Hamburger id={'hamburger'} onClick={toggleMobileMenu}>
            <HamburgerPart/>
            <HamburgerPart withMargin/>
            <HamburgerPart/>
        </Hamburger>
    )
}

export default HamburgerMenu;
